import { generateText } from '@tiptap/core';

import tiptapExtensionsView from './tiptapExtensionsView';

export const getTextFromTiptapJSON = (str: string) =>
  typeof str === 'string' && str?.startsWith('{')
    ? generateText(JSON.parse(str), tiptapExtensionsView, {
        // define a custom block separator if you want to
        blockSeparator: '\n',
        // overwrite `renderText` method of nodes
        textSerializers: {
          hardBreak: () => '\n',
        },
      })
    : str;
